// src/components/components/wiki/BubbleMenuComponent.tsx

import React, { FC } from 'react';
import { Editor } from '@tiptap/react';
import { BubbleMenu } from '@tiptap/react/menus';

import {
  FaBold,
  FaItalic,
  FaStrikethrough,
  FaLink,
  FaUnlink,
  FaCode,
} from 'react-icons/fa';

// Cast icons so TS is happy using them as JSX components
const BoldIcon = FaBold as React.ComponentType;
const ItalicIcon = FaItalic as React.ComponentType;
const StrikeIcon = FaStrikethrough as React.ComponentType;
const CodeIcon = FaCode as React.ComponentType;
const LinkIcon = FaLink as React.ComponentType;
const UnlinkIcon = FaUnlink as React.ComponentType;

interface BubbleMenuProps {
  editor: Editor | null;
}

const BubbleMenuComponent: FC<BubbleMenuProps> = ({ editor }) => {
  if (!editor) {
    return null;
  }

  return (
    <BubbleMenu
      className="menu-bubble"
      editor={editor}
      // v3 uses `options` (Floating UI), not `tippyOptions`
      options={{
        placement: 'top',
      }}
    >
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleBold().run()}
        className={`menu-button ${editor.isActive('bold') ? 'is-active' : ''}`}
        title="Bold"
      >
        <BoldIcon />
      </button>

      <button
        type="button"
        onClick={() => editor.chain().focus().toggleItalic().run()}
        className={`menu-button ${editor.isActive('italic') ? 'is-active' : ''}`}
        title="Italic"
      >
        <ItalicIcon />
      </button>

      <button
        type="button"
        onClick={() => editor.chain().focus().toggleStrike().run()}
        className={`menu-button ${editor.isActive('strike') ? 'is-active' : ''}`}
        title="Strikethrough"
      >
        <StrikeIcon />
      </button>

      <button
        type="button"
        onClick={() => editor.chain().focus().toggleCode().run()}
        className={`menu-button ${editor.isActive('code') ? 'is-active' : ''}`}
        title="Code"
      >
        <CodeIcon />
      </button>

      <button
        type="button"
        onClick={() => {
          const previousUrl = editor.getAttributes('link').href;
          const url = window.prompt('URL', previousUrl);

          if (url === null) return;

          if (url === '') {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
            return;
          }

          editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
        }}
        className={`menu-button ${editor.isActive('link') ? 'is-active' : ''}`}
        title="Link"
      >
        <LinkIcon />
      </button>

      <button
        type="button"
        onClick={() => editor.chain().focus().unsetLink().run()}
        disabled={!editor.isActive('link')}
        className="menu-button"
        title="Unlink"
      >
        <UnlinkIcon />
      </button>
    </BubbleMenu>
  );
};

export default BubbleMenuComponent;
